'use client';

import { useTranslations } from 'next-intl';
import type { JSX } from 'react';

import { APP_HEADER_SCROLL_MARGIN_CLASS } from '@/components/layout/app-header-sticky-top';
import { LandingProductLink } from '@/components/support-mainnet/landing-product-link';
import { LandingSectionReveal } from '@/components/support-mainnet/landing-section-reveal';
import { AnimatedButton } from '@/components/ui/animated-button';
import { FEED_CARD_OUTLINE_INTERACTION } from '@/lib/ui/feed-card-chrome';
import { cn } from '@/lib/ui/utils';

const PANEL_SHELL_CLASS: string = cn(
  'share-channel-card group relative isolate w-full overflow-hidden rounded-card border border-solid border-border-primary bg-[var(--gray-800)]',
  FEED_CARD_OUTLINE_INTERACTION,
);

export function LaunchCtaPanel(): JSX.Element {
  const t = useTranslations('supportMainnet.launch');

  return (
    <section aria-labelledby="launch-cta-heading" className="w-full">
      <LandingSectionReveal>
        <div className={PANEL_SHELL_CLASS}>
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 z-0 bg-[url('/images/support-mainnet/Launch-bg.png')] bg-cover bg-center"
            data-testid="launch-cta-panel-background"
          />
          <span aria-hidden className="share-channel-card__border-shimmer">
            <span className="share-channel-card__border-beam share-channel-card__border-beam--glow" />
            <span className="share-channel-card__border-beam" />
          </span>
          <div className="relative z-10 mx-auto flex max-w-2xl flex-col items-center gap-8 px-6 py-14 text-center sm:px-10">
            <header className="flex flex-col items-center gap-4">
              <h2
                id="launch-cta-heading"
                className={cn(
                  'text-balance text-display-sm text-foreground-primary',
                  APP_HEADER_SCROLL_MARGIN_CLASS,
                )}
              >
                {t('launchTitle')}
              </h2>
              <p className="text-pretty text-body-lg text-foreground-tertiary">
                {t('launchLead')}
                <br />
                {t('launchLeadSecondary')}
              </p>
            </header>

            <AnimatedButton asChild variant="primary" size="lg">
              <LandingProductLink surface="lower">{t('launchSubmit')}</LandingProductLink>
            </AnimatedButton>
          </div>
        </div>
      </LandingSectionReveal>
    </section>
  );
}
